<template lang="html">
<span class="margin-help">
  <a id="btn-help">
    <i class="fa fa-question-circle" aria-hidden="true"></i>
  </a>
  <popover target="#btn-help" trigger="hover">
    <template slot="popover">
      <slot></slot>
    </template>
  </popover>
</span>
</template>

<script>

import { Popover, Btn } from 'uiv'

export default {

  components: {
    Popover,
    Btn
  },

  name: 'help-popper',

}

</script>

<style lang="css">

.margin-help{
  margin-left: 5px;
  padding-bottom: -50px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/basicos/helpPopper.vue